import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {
  SaleSubmissions,
} from 'src/app/models/sales/sales.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class SaleSubmissionsDataSource extends MatDataSource<SaleSubmissions>  {
  private cachedSaleSubmissions: SaleSubmissions[];
  private readonly saleSubmissions$: BehaviorSubject<SaleSubmissions[]>;
  private readonly sortByKeySubject$: BehaviorSubject<'ASC' | 'DESC' | null> =
    new BehaviorSubject<'ASC' | 'DESC' | null>('DESC');
  private readonly subscription$ = new Subscription();

  public constructor(data: SaleSubmissions[], sort: MatSort) {
    super(data, sort);
    this.setFilterPredicate();
  }

  setFilterPredicate(): void {
    this.filterPredicate = (submission: SaleSubmissions, filterValue: string = '') => {
      return 'lotNumber,vetName,data'
        .split(',')
        .some((key) => {
          return (
            submission[key as keyof SaleSubmissions] &&
            new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
              submission[key as keyof SaleSubmissions]
            )
          );
        });
    };
  }


  
}
